import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Button, Grid } from '@material-ui/core'
import swal from 'sweetalert'
import { Modal6 } from '../../Modals/ModalSec6/Modal6'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { getManagementPlanMitigations } from '../../../../../services/Elegibilidad/get'
import { deleteManagementPlanMitigation } from '../../../../../services/Elegibilidad/delete'
// import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
// import { Modal6Edit } from '../../Modals/ModalSec6Edit/Modal6Edit'
// import GetAppIcon from '@material-ui/icons/GetApp'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

const Table61 = ({
  idEnviromentalImpact,
  formikSetFielValues,
  acordionCheck,
}) => {
  const {
    idElegibilityForm,
    // ImplementationDateStart
  } = useFormElegibilidad()
  // const idElegibilityForm = 739

  const [body, setBody] = useState({})
  const [openToEdit, setOpenToEdit] = useState(false)
  const [openSec6, setOpenSec6] = useState(false)
  const [tableData, setTableData] = useState([])

  const columns = [
    {
      title: 'Medida de Mitigación',
      field: 'MitigationDetail',
      type: 'string',
      cellStyle: { width: '80%' },
    },
    {
      title: 'Inicio',
      field: 'StartDate',
      type: 'date',
      align: 'center',
      dateSetting: {
        format: 'DD/MM/YYYY',
      },
    },
    {
      title: 'Finalización',
      field: 'EndDate',
      type: 'date',
      align: 'center',
      dateSetting: {
        format: 'DD/MM/YYYY',
      },
    },
  ]

  const getDataTable = async (idElegibilityForm, idEnviromentalImpact) => {
    try {
      if (idElegibilityForm) {
        const params = `${idElegibilityForm}/${idEnviromentalImpact}`
        const response = await getManagementPlanMitigations(params)
        if (response.Success) {
          setTableData(response.Data)
          if (response.Data.length === 0) {
            formikSetFielValues(`validateTable${idEnviromentalImpact}`, false)
          } else {
            formikSetFielValues(`validateTable${idEnviromentalImpact}`, true)
          }
        }
      } else {
        throw Error('No se pudo obtener el ID del formulario')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await deleteManagementPlanMitigation(id)
      if (response.Success) {
        swal({
          title: 'Registro eliminado',
          icon: 'success',
        })
      } else {
        throw Error('Error eliminando registro')
      }
      getDataTable(idElegibilityForm, idEnviromentalImpact)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    let isMounted = true
    try {
      if (idElegibilityForm) {
        const params = `${idElegibilityForm}/${idEnviromentalImpact}`
        getManagementPlanMitigations(params)
          .then((response) => {
            if (isMounted) {
              if (response.Success) {
                if (response.Data.length > 0) {
                  setTableData(response.Data)
                  formikSetFielValues(
                    `validateTable${idEnviromentalImpact}`,
                    true,
                  )
                } else {
                  formikSetFielValues(
                    `validateTable${idEnviromentalImpact}`,
                    false,
                  )
                }
              } else {
                throw Error(response.Message)
              }
            }
          })
          .catch((error) => console.log(error.message))
      } else {
        throw Error('No se pudo acceder al ID del formulario')
      }
    } catch (error) {}
    return () => {
      isMounted = false
    }
  }, [])

  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData || []}
            actions={[
              // {
              //   icon: () => <AddIcon style={{ color: 'green' }} />,
              //   tooltip: 'Agregar',
              //   position: 'toolbar',
              //   onClick: () => {
              //     setOpenToEdit(false)
              //     setOpenSec6(true)
              //   },
              // },

              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
                onClick: () => {
                  setOpenToEdit(false)
                  setOpenSec6(true)
                },
              },

              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setBody(rowData)
                  setOpenToEdit(true)
                  setOpenSec6(true)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdManagementPlanMitigation)
                    }
                  })
                },
              },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              // filtering: true,
              paging: false,
              // pageSizeOptions: [2, 5, 10, 20],
              // pageSize: 5,
              // paginationType: 'stepped',
              showFirstLastPageButtons: false,
              // pagination=false,
              // paginationPosition: 'bottom',

              exportFileName: 'TableData',
              // addRowPosition: 'first',
              actionsColumnIndex: -1,
              // selection: true,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              // selectionProps: (rowData) => ({
              //   disabled: rowData.age == null,
              //   // color:"primary"
              // }),
              // grouping: true,
              columnsButton: false,
              toolbarButtonAlignment: 'left',
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{ Add: () => <AddIcon /> }}
          />
        </Grid>
      </Grid>
      {openSec6 && (
        <Modal6
          openSec6={openSec6}
          setOpenSec6={setOpenSec6}
          idElegibilityForm={idElegibilityForm}
          idEnviromentalImpact={idEnviromentalImpact}
          edit={openToEdit}
          setEdit={setOpenToEdit}
          row={body}
          getDataTable={getDataTable}
          tableData={tableData}
        />
      )}
    </div>
  )
}

export default React.memo(Table61)
